import './Hero.css';

export default function Hero() {
  return (
    <section className="hero">
      {/* Background decorations */}
      <div className="hero__bg">
        <div className="hero__blob hero__blob--1" />
        <div className="hero__blob hero__blob--2" />
        <div className="hero__blob hero__blob--3" />
        <div className="hero__grid" />
      </div>

      <div className="container hero__inner">
        {/* Left: Text */}
        <div className="hero__content">
          <div className="hero__badge">
            <span className="hero__badge-dot" />
            Version bêta disponible
          </div>

          <h1 className="hero__title">
            Finies les <span className="hero__title-highlight">contraintes.</span><br />
            Place à l'<span className="hero__title-highlight hero__title-highlight--2">autonomie.</span>
          </h1>

          <p className="hero__subtitle">
            Evolify accompagne les familles à construire des routines durables, grâce à une gamification douce et bienveillante. Sans cris pour les parents et sans frustration pour les enfants.
          </p>

          <div className="hero__stats">
            <div className="hero__stat">
              <span className="hero__stat-number" data-countup="2" data-suffix=" min">2 min</span>
              <span className="hero__stat-label">par jour max</span>
            </div>
            <div className="hero__stat-divider" />
            <div className="hero__stat">
              <span className="hero__stat-number">4-5</span>
              <span className="hero__stat-label">tâches / enfant</span>
            </div>
            <div className="hero__stat-divider" />
            <div className="hero__stat">
              <span className="hero__stat-number" data-countup="100" data-suffix="%">100%</span>
              <span className="hero__stat-label">co-construit</span>
            </div>
          </div>

          <div className="hero__actions">
            
            <a href="#fonctionnement" className="btn-secondary">
              <span>▶</span> Voir comment ça marche
            </a>
            <a href="#contact" className="btn-primary hero__btn-main">
              Rejoindre la bêta
              <span>→</span>
            </a>
          </div>

          <p className="hero__note">App gratuite · Achat in-app proposé</p>

          {/* Spotify */}
          <div className="hero__spotify">
            <span className="hero__spotify-label">🎵 Écoutez la chanson d'EVO !</span>
            <a
              href="https://open.spotify.com/intl-fr/album/78WL2dwTJ3gGDVaVScXZII?si=bgnzrDOUTO-cWaG9UFNg2A"
              className="hero__spotify-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg className="hero__spotify-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path fill="currentColor" d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
              </svg>
              Écouter sur Spotify
            </a>
          </div>
        </div>

        {/* Right: App mockup */}
        <div className="hero__visual">
          <div className="hero__phone-wrapper">
            {/* Phone shell with real screenshot inside */}
            <div className="hero__phone">
              <div className="hero__phone-notch" />
              <img
                src="/images/evolify-app-screen.jpg"
                alt="Aperçu de l'application Evolify"
                className="hero__phone-screen"
              />
            </div>

            {/* Floating cards */}
            <div className="hero__float hero__float--xp">
              <span className="hero__float-icon">⚡</span>
              <div>
                <p className="hero__float-title">+150 XP gagnés !</p>
                <p className="hero__float-sub">Faire son lit · Rare</p>
              </div>
            </div>

            <div className="hero__float hero__float--level">
              <span className="hero__float-icon">🎉</span>
              <div>
                <p className="hero__float-title">Niveau 8 débloqué !</p>
                <p className="hero__float-sub">Nouvelle carte à choisir</p>
              </div>
            </div>

            <div className="hero__float hero__float--evo">
              <span className="hero__float-icon">💜</span>
              <div>
                <p className="hero__float-title">Message d'Evo</p>
                <p className="hero__float-sub">"Bravo je suis fier de toi !"</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="hero__scroll">
        <div className="hero__scroll-mouse">
          <div className="hero__scroll-dot" />
        </div>
        <p>Découvrir</p>
      </div>
    </section>
  );
}
